import { CAMPAIGN_MAX_SIZE } from '@common/constants';

import { State } from '@campaign/types';

export function createInitialState(
  selectedCampaignTab: State['selectedCampaignTab'] = 0
): State {
  return {
    auth: {
      accessToken: undefined,
      expires: undefined,
      inviteToken: undefined,
      resetPasswordToken: undefined,
    },
    campaignList: [],
    errors: {
      campaignList: '',
      modal: {
        errorCode: '',
        isModalOpen: false,
      },
      userCampaignList: '',
    },
    initialized: false,
    loadGenerations: {
      campaignList: {
        generation: 0,
        isLoggedIn: false,
      },
      userCampaignList: {
        generation: 0,
      },
    },
    loading: {
      campaignList: true,
      userCampaignList: false,
    },
    loggedInUser: {
      firstName: '',
      hasPhoneNumber: false,
      id: '',
      isLogged: false,
      lastName: '',
      token: null,
    },
    pagination: {
      campaignList: {
        limit: CAMPAIGN_MAX_SIZE,
        offset: 0,
        total: 0,
      },
      userCampaignList: {
        limit: CAMPAIGN_MAX_SIZE,
        offset: 0,
        total: 0,
      },
    },
    selectedCampaignTab,
    userCampaignList: [],
  };
}

export const initialState = createInitialState();
